// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lp-1";
export var messageSideRight = "_lp-2";
export var orderLookupBubbleContainer = "_lp-0";
export var submitButton = "_lp-3";